export default __webpack_public_path__ + "static/media/memoire.851cbeb1.png";